import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AlertService} from '../shared/alert.service';
import {RestService} from '../shared/rest/rest.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AnimationUtil} from '../shared/material/animation-util';
import {EnvironmentService, TranslateService} from "bos-commons";
import {BehaviorSubject} from "rxjs";
import {CustomIconService} from "../shared/custom-icon.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    AnimationUtil.submitButtonAnimation
  ]
})

export class LoginComponent implements OnInit {

  logoutEmitter = new BehaviorSubject(false);
  inProgress = false;
  success = false;
  domainNames = [];
  loginProperties: {url: string, name: string, style: string, customName?: string, customIcon?: string }[] = [];

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.minLength(3)]),
    password: new FormControl('', [Validators.required, Validators.minLength(3)]),
    rememberMe: new FormControl(false, []),
    domain: new FormControl('', [])
  });

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private http: HttpClient,
    private alertService: AlertService,
    private restService: RestService,
    private env: EnvironmentService,
    private customIcon: CustomIconService,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(queryMap => {
      if(queryMap.has('message')) {
       this.alertService.infoWithoutTitle(queryMap.get('message'));
      }
      if(queryMap.has('logout')) {
        this.logoutEmitter.next(true);
      }
      if (queryMap.has('progress') && queryMap.get('progress') === 'true') {
        this.alertService.infoWithoutTitle(this.translateService.translateWithArgs('Login.progress'));
        this.inProgress = true;
      }
    });
    this.restService.getOauth2Properties().subscribe(val => {
      this.loginProperties = [...val];
    });
  }

  loginWith(provider: {url: string, name: string}) {
    location.href = provider.url;
  }

  login() {
    if (!this.inProgress) {
      this.inProgress = true;
      this.restService.authenticate(
          this.loginForm.value.username,
          this.loginForm.value.password,
          this.loginForm.value.rememberMe,
          this.loginForm.value.domain)
          .subscribe(response => {
              this.success = true;
              setTimeout(() => {
                window.location.href = response.url;
              }, 300)
          }, error => {
            this.markFailure(error)
          });
    }
  }

  private markFailure(error?: any) {
    this.restService.handleError(error);
    this.inProgress = false;
    this.success = false;
  }

  refresh() {
    this.logoutEmitter.next(false);
    if(this.env.environment.afterLogoutUrl?.length > 0) {
      console.debug("Redirecting to external logout url", this.env.environment.afterLogoutUrl);
      window.location.href = this.env.environment.afterLogoutUrl;
    } else {
      this.router.navigate(['/boslogin'], {preserveFragment: false});
    }
  }
}
